import React, { useState } from 'react';
import { MapPinIcon, ClockIcon, CheckIcon, DollarSignIcon } from 'lucide-react';
import { BottomNav } from '../components/BottomNav';
import { DriverToggle } from '../components/DriverToggle';
export const DriverRides: React.FC = () => {
  const [activeTab, setActiveTab] = useState('today');
  const rides = {
    today: [{
      id: '1',
      time: '2:30 PM',
      pickup: 'JB Sentral',
      dropoff: 'Orchard Road',
      type: 'Premium',
      fare: 120,
      currency: 'RM',
      status: 'completed'
    }, {
      id: '2',
      time: '11:45 AM',
      pickup: 'Taman Molek',
      dropoff: 'Marina Bay',
      type: 'Standard',
      fare: 85,
      currency: 'RM',
      status: 'completed'
    }],
    week: [{
      id: '1',
      date: 'Today',
      trips: 5,
      earnings: 425
    }, {
      id: '2',
      date: 'Yesterday',
      trips: 8,
      earnings: 680
    }, {
      id: '3',
      date: 'Dec 18',
      trips: 6,
      earnings: 510
    }]
  };
  return <div className="min-h-screen bg-background pb-16" data-id="element-355">
      <div className="p-6" data-id="element-356">
        <div className="flex items-center justify-between mb-6" data-id="element-357">
          <h1 className="text-xl font-semibold" data-id="element-358">My Rides</h1>
          <DriverToggle data-id="element-359" />
        </div>
        <div className="flex mb-6 bg-card rounded-lg p-1" data-id="element-360">
          <button className={`flex-1 py-2 rounded-md text-center ${activeTab === 'today' ? 'bg-primary text-background' : ''}`} onClick={() => setActiveTab('today')} data-id="element-361">
            Today
          </button>
          <button className={`flex-1 py-2 rounded-md text-center ${activeTab === 'week' ? 'bg-primary text-background' : ''}`} onClick={() => setActiveTab('week')} data-id="element-362">
            This Week
          </button>
        </div>
        {activeTab === 'today' && <div className="space-y-4" data-id="element-363">
            {rides.today.map(ride => <div key={ride.id} className="card" data-id="element-364">
                <div className="flex justify-between items-start mb-3" data-id="element-365">
                  <div className="flex items-center" data-id="element-366">
                    <ClockIcon size={16} className="text-primary mr-2" data-id="element-367" />
                    <span className="text-sm" data-id="element-368">{ride.time}</span>
                  </div>
                  <div className="chip" data-id="element-369">
                    {ride.currency} {ride.fare}
                  </div>
                </div>
                <div className="flex items-start mb-2" data-id="element-370">
                  <MapPinIcon size={16} className="text-primary mt-1 mr-2" data-id="element-371" />
                  <div data-id="element-372">
                    <p className="text-sm text-white text-opacity-70" data-id="element-373">From</p>
                    <p className="font-medium" data-id="element-374">{ride.pickup}</p>
                  </div>
                </div>
                <div className="flex items-start mb-3" data-id="element-375">
                  <MapPinIcon size={16} className="text-primary mt-1 mr-2" data-id="element-376" />
                  <div data-id="element-377">
                    <p className="text-sm text-white text-opacity-70" data-id="element-378">To</p>
                    <p className="font-medium" data-id="element-379">{ride.dropoff}</p>
                  </div>
                </div>
                <div className="flex justify-between items-center" data-id="element-380">
                  <span className="text-sm text-white text-opacity-70" data-id="element-381">
                    {ride.type}
                  </span>
                  <div className="flex items-center text-green-500" data-id="element-382">
                    <CheckIcon size={16} className="mr-1" data-id="element-383" />
                    <span className="text-sm font-medium" data-id="element-384">Completed</span>
                  </div>
                </div>
              </div>)}
          </div>}
        {activeTab === 'week' && <div className="space-y-3" data-id="element-385">
            {rides.week.map(day => <div key={day.id} className="card" data-id="element-386">
                <div className="flex items-center justify-between mb-3" data-id="element-387">
                  <div data-id="element-388">
                    <p className="font-medium" data-id="element-389">{day.date}</p>
                    <p className="text-sm text-white text-opacity-70" data-id="element-390">
                      {day.trips} trips
                    </p>
                  </div>
                  <div className="text-right" data-id="element-391">
                    <div className="flex items-center text-primary" data-id="element-392">
                      <DollarSignIcon size={16} className="mr-1" data-id="element-393" />
                      <span className="font-bold text-lg" data-id="element-394">
                        RM {day.earnings}
                      </span>
                    </div>
                  </div>
                </div>
              </div>)}
          </div>}
      </div>
      <BottomNav data-id="element-395" />
    </div>;
};